import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ModalService } from '@app/core/services';
import { EulaModalComponent } from '@app/portal/eula-modal.component';
import { NgbAccordionModule, NgbActiveModal, NgbAlertModule, NgbDateNativeAdapter, NgbDateParserFormatter, NgbDropdownModule, NgbModule, NgbToastModule, NgbTypeaheadConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { CustomAccordionComponent } from './components/custom-accordion.component';
import { ErrorListComponent } from './components/forms/error-list.component';
import { PasswordBaseComponent } from './components/forms/password-base.component';
import { SubmitButtonComponent } from './components/forms/submit-button.component';
import { ModalContainerValueComponent } from './components/modal-container-value.component';
import { ModalContainerComponent } from './components/modal-container.component';
import { NotificationComponent } from './components/notifications/notification.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { ToastsContainerComponent } from './components/toasts-container.component';
import {
  AutofocusDirective, FileValueAccessorDirective, IndeterminateDirective, InputFieldLabcorpClassDirective, InputGroupDirective,
  ScrollTopDirective, ShortDateInputMaskDirective, SortableHeaderDirective
} from './directives';
import { LoadingComponent } from './loading.component';
import { MessageModalComponent } from './message-modal.component';
import { NgbLocalDateParserFormatter } from './ngb-local-date-parser-formatter';
import { PageSpinnerComponent } from './page-spinner.component';
import { PaginationComponent } from './pagination.component';
import { FileSizePipe, PluralizePipe, SelectionsCountPipe } from './pipes';
import { PopupDatePickerComponent } from './popup-date-picker.component';
import { PopupNgbDatePickerComponent } from './popup-ngbDate-picker.component ';

const declaredModules = [
  CommonModule,
  FormsModule,
  NgbModule,
  NgbAlertModule,
  NgSelectModule,
  NgbToastModule,
  NgbAccordionModule,
  NgbDropdownModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  NgxMaskDirective,
  NgxMaskPipe
];

const declarations = [
  PasswordBaseComponent,
  ErrorListComponent,
  LoadingComponent,
  AutofocusDirective,
  FileValueAccessorDirective,
  FileSizePipe,
  InputGroupDirective,
  ShortDateInputMaskDirective,
  PluralizePipe,
  ScrollTopDirective,
  SelectionsCountPipe,
  SubmitButtonComponent,
  NotificationComponent,
  NotificationsComponent,
  SortableHeaderDirective,
  InputFieldLabcorpClassDirective,
  PaginationComponent,
  ModalContainerComponent,
  ModalContainerValueComponent,
  ToastsContainerComponent,
  PopupDatePickerComponent,
  PopupNgbDatePickerComponent,
  MessageModalComponent,
  IndeterminateDirective,
  EulaModalComponent,
  PageSpinnerComponent,
  CustomAccordionComponent
];
@NgModule({
  declarations: [...declarations],
  imports: [...declaredModules],
  exports: [...declaredModules, ...declarations],
  providers: [
    NgbActiveModal,
    NgbTypeaheadConfig,
    NgbDateNativeAdapter,
    NgbLocalDateParserFormatter,
    ModalService,
    { provide: NgbDateParserFormatter, useClass: NgbLocalDateParserFormatter, },
    provideNgxMask()
  ],
})
export class SharedModule { }
